import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import axios from 'axios';
import React, { useState } from 'react';

interface CameraDeviceDeleteDialogProps {
  mappingId: number | null;
  serialNumber?: string | null;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
}

export const CameraDeviceDeleteDialog = ({ mappingId, serialNumber, open, onClose, onDeleted }: CameraDeviceDeleteDialogProps) => {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const close = () => {
    if (deleting) return;
    setError('');
    onClose();
  };

  const confirmDelete = async () => {
    if (mappingId == null) return;
    setDeleting(true);
    setError('');
    try {
      const response = await axios.delete<{ status: number; msg?: string }>(`/api/admin/camera-devices/${mappingId}`);
      if (response.data.status !== 0) throw new Error(response.data.msg || 'Não foi possível excluir a câmera.');
      onDeleted();
      onClose();
    } catch (failure) {
      const message = axios.isAxiosError(failure)
        ? failure.response?.data?.msg || failure.response?.data?.detail || failure.response?.data?.title
        : failure instanceof Error
        ? failure.message
        : null;
      setError(message || 'Não foi possível excluir a câmera. Tente novamente.');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>Excluir câmera</DialogTitle>
      <DialogContent>
        <Typography>Ao excluir a câmera {serialNumber}, o dispositivo também será excluído da HAT Cloud e o vínculo com este veículo será removido.</Typography>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button color="secondary" disabled={deleting} onClick={close}>
          Cancelar
        </Button>
        <Button color="error" variant="contained" disabled={deleting} onClick={confirmDelete}>
          Excluir câmera
        </Button>
      </DialogActions>
    </Dialog>
  );
};
